/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { BrokerProfileLinkResponseDto } from './brokerProfileLinkResponseDto';
import type { BrokerProfileResponseDtoExperienceSinceYear } from './brokerProfileResponseDtoExperienceSinceYear';
import type { BrokerProfileResponseDtoFullNameWithTitles } from './brokerProfileResponseDtoFullNameWithTitles';
import type { BrokerProfileResponseDtoPhotoUrl } from './brokerProfileResponseDtoPhotoUrl';
import type { BrokerProfileResponseDtoWebBio } from './brokerProfileResponseDtoWebBio';

export interface BrokerProfileResponseDto {
  /** @nullable */
  fullNameWithTitles: BrokerProfileResponseDtoFullNameWithTitles;
  /** @nullable */
  photoUrl: BrokerProfileResponseDtoPhotoUrl;
  /** @nullable */
  webBio: BrokerProfileResponseDtoWebBio;
  /** @nullable */
  experienceSinceYear: BrokerProfileResponseDtoExperienceSinceYear;
  isPublicProfileEnabled: boolean;
  isMemberOfNarks: boolean;
  isMemberOfRealUnia: boolean;
  isMemberOfZrks: boolean;
  links: BrokerProfileLinkResponseDto[];
}
